module.exports = __webpack_public_path__ + "static/img/kk.52b5a2c1.svg";